import {
  AspectRatio,
  BoxProps,
  Center,
  Box,
  Spinner,
  Image,
} from '@chakra-ui/react';
import { useState } from 'react';

type Props = {
  videoUrl: string;
  loop?: boolean;
  previewImageUrl?: string | undefined;
  videoPosition?: 'left' | 'center' | 'right';
  fadInOnLoad?: boolean;
};

const VideoBlock = ({
  videoUrl,
  height,
  width,
  children,
  loop = true,
  previewImageUrl,
  videoPosition = 'center',
  fadInOnLoad = false,
  ...others
}: Props & BoxProps) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Center width="full" {...others} zIndex={-5} userSelect="none">
      <AspectRatio
        ratio={1}
        width={width || { base: '300px', sm: '400px' }}
        height={height || width || { base: '300px', sm: '400px' }}
        backgroundColor="white"
      >
        <Box>
          <video
            key={videoUrl}
            style={{
              width: '100%',
              height: '100%',
              objectPosition: videoPosition,
              visibility: isLoading ? 'hidden' : 'visible',
              opacity: isLoading && fadInOnLoad ? 0 : 1,
              transition: 'opacity, 0.7s ease-in-out',

              // avoid small black lines bug..
              outline: '4px solid white',
              outlineOffset: '-4px',
            }}
            loop={loop}
            autoPlay
            muted
            playsInline
            controls={false}
            onLoadStart={() => setIsLoading(true)}
            onLoadedData={() => setIsLoading(false)}
          >
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          {/* // possible children */}
          {children}

          {previewImageUrl && (
            <Image
              width="100%"
              height="100%"
              objectFit="contain"
              objectPosition={videoPosition}
              zIndex={-1}
              alt="video preview"
              src={previewImageUrl}
              position="absolute"
            />
          )}
        </Box>
      </AspectRatio>
      {isLoading && (
        <Center
          width="full"
          color="primaryColor"
          style={{
            left: 0,
            right: 0,
            position: 'absolute',
            width: '100%',
            visibility: 'hidden',
          }}
        >
          <Spinner />
        </Center>
      )}
    </Center>
  );
};

export default VideoBlock;
